module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/pr-147.vue");


//////////////////
// WEBPACK FOOTER
// ./en/contribution/pr.md
// module id = 564
// module chunks = 411